import { netsparkAxios } from 'core/services/HTTPService';
import { getBookingSellerDataUrl } from 'pages/Dashboard/api/apiUrls';
import { IRequestPaging } from 'core/services/HTTPService.models';
import { IBookingDataItem } from '@dashboardWireline/WirelineDepartments/WIrelineDepartament.models';

const getBookingSellerData = (signal: AbortSignal, params: object) => netsparkAxios
  .get<IRequestPaging<IBookingDataItem[]>>(getBookingSellerDataUrl, { signal, params });

export default getBookingSellerData;
